import React from 'react';
import { Creative } from '../../../../general/icons/Creative';
import { Folder } from '../../icons/Folder';
import '../styles.scss';
import {
  CHNode,
  CHNodeIsFolder,
  CHNodeIsCreativeFolder,
  CHNodeIsCoreDirectory,
} from '../../../../general/node';
import { IconSelector } from '../../../../general/components/FullscreenPreview/viewers/MediaUnknown';

export const NodeIcon: React.FC<{ node: CHNode }> = ({ node }) => {
  if (CHNodeIsCreativeFolder(node)) {
    return <Creative />;
  } else if (CHNodeIsCoreDirectory(node)) {
    return <Folder classes={{ root: 'ch-node-icon_core-directory' }} />;
  } else if (CHNodeIsFolder(node)) {
    return <Folder />;
  } else {
    return (
      <IconSelector filename={node.name} defaultIcon className="ch-node-icon__fallback-icon" />
    );
  }
};
